export enum CheckoutStep {
  Unknown = 'Unknown',
  PaymentDetails = 'paymentDetails',
  PaymentType = 'paymentType',
  PaymentMethod = 'paymentMethod',
  Review = 'review',
  Confirmation = 'confirmation',
  Pending = 'pending',
}
